import apiClient from './apiClient';

const roomTypeService = {
  // Room Types
  getAll: () => apiClient.get('/v1/room-types'),
  getById: (id) => apiClient.get(`/v1/room-types/${id}`),
  create: (data) => apiClient.post('/v1/room-types', data),
  update: (id, data) => apiClient.put(`/v1/room-types/${id}`, data),
  remove: (id) => apiClient.del(`/v1/room-types/${id}`),

  // Amenities
  getAmenities: () => apiClient.get('/v1/room-amenities'),
  createAmenity: (data) => apiClient.post('/v1/room-amenities', data),
};

export default roomTypeService;
